export default "__VITE_ASSET__01c23127__"